// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hn3op","newExpiryDate":"styles_newExpiryDate__18euu","footer":"styles_footer__1V2tr"};